// Minimal level-aware console logger. Replaces the (Vue 2-only) vuejs-logger.
// Components keep using `this.$log.*` via the plugin below; non-component code
// (store, axios) imports the singleton directly.

const LEVELS = { debug: 0, info: 1, warn: 2, error: 3 }

function createLogger(level) {
  const threshold = LEVELS[level] ?? LEVELS.debug

  const make = (name, fn) => (...args) => {
    if (LEVELS[name] >= threshold) {
      fn(`|${name.toUpperCase()}|`, ...args)
    }
  }

  return {
    debug: make('debug', console.debug),
    info: make('info', console.info),
    warn: make('warn', console.warn),
    error: make('error', console.error),
  }
}

const logger = createLogger(import.meta.env.PROD ? 'error' : 'debug')

export default logger

export const loggerPlugin = {
  install(app) {
    app.config.globalProperties.$log = logger
  },
}
